import { Routes } from '@angular/router';
import { companyAdminGuard, maintenancePortalGuard, signedInGuard } from './core/services/maintenance-portal.guard';
import { MaintenanceShell } from './shell/maintenance-shell/maintenance-shell';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/maintenance-login').then((m) => m.MaintenanceLogin),
  },
  // Maintenance companies are not workspace members, so their pages sit outside the workspace shell.
  {
    path: 'company-invitations/:token',
    loadComponent: () => import('./pages/company/company-invitation').then((m) => m.CompanyInvitation),
  },
  {
    path: 'company',
    canActivate: [signedInGuard],
    loadComponent: () => import('./pages/company/company-shell').then((m) => m.CompanyShell),
    children: [
      { path: '', loadComponent: () => import('./pages/company/company-dashboard').then((m) => m.CompanyDashboard) },
      { path: 'jobs', loadComponent: () => import('./pages/company/company-jobs').then((m) => m.CompanyJobs) },
      { path: 'jobs/:id', loadComponent: () => import('./pages/company/company-job').then((m) => m.CompanyJobPage) },
      { path: 'schedule', loadComponent: () => import('./pages/company/company-schedule').then((m) => m.CompanySchedule) },
      { path: 'landlords', loadComponent: () => import('./pages/company/company-landlords').then((m) => m.CompanyLandlords) },
      { path: 'team', canActivate: [companyAdminGuard], loadComponent: () => import('./pages/company/company-team').then((m) => m.CompanyTeam) },
      { path: 'profile', loadComponent: () => import('./pages/company/company-profile').then((m) => m.CompanyProfile) },
    ],
  },
  {
    path: '',
    component: MaintenanceShell,
    canActivate: [maintenancePortalGuard],
    canActivateChild: [maintenancePortalGuard],
    children: [
      { path: 'communications', data: { permission: 'COMMUNICATION_VIEW' }, loadComponent: () => import('./pages/communications/maintenance-communications').then(m => m.MaintenanceCommunications) },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/maintenance-dashboard').then((m) => m.MaintenanceDashboard),
      },
      {
        path: 'work-orders',
        loadComponent: () => import('./pages/work-orders/work-orders').then(m => m.WorkOrders),
        data: { permission: 'MAINTENANCE_VIEW', title: 'Work Orders', subtitle: 'Review assigned requests, priority, SLA state, and next actions.' },
      },
      {
        path: 'schedule',
        loadComponent: () => import('./pages/work-orders/work-orders').then(m => m.WorkOrders),
        data: { permission: 'MAINTENANCE_VIEW', title: 'Schedule', subtitle: 'Plan visits, preferred windows, and on-site availability.' },
      },
      {
        path: 'inspections',
        loadComponent: () => import('./pages/section/maintenance-section').then((m) => m.MaintenanceSection),
        data: { permission: 'INSPECTION_VIEW', title: 'Inspections', subtitle: 'Track maintenance follow-ups, photos, and completion notes.' },
      },
      {
        path: 'parts',
        loadComponent: () => import('./pages/section/maintenance-section').then((m) => m.MaintenanceSection),
        data: { permission: 'MAINTENANCE_BILLING_MANAGE', title: 'Parts & Costs', subtitle: 'Capture materials, cost estimates, and billable repair details.' },
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/section/maintenance-section').then((m) => m.MaintenanceSection),
        data: { permission: 'REPORT_VIEW', title: 'Reports', subtitle: 'Resolution trends, workload, SLA risk, and vendor performance.' },
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/section/maintenance-section').then((m) => m.MaintenanceSection),
        data: { permission: 'PERSONAL_PREFERENCES_MANAGE', title: 'Settings', subtitle: 'Service profile, notification preferences, and availability controls.' },
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
